import { render, staticRenderFns } from "./inviteSwitch.vue?vue&type=template&id=f260a898&scoped=true&lang=html&"
import script from "./inviteSwitch.vue?vue&type=script&lang=js&"
export * from "./inviteSwitch.vue?vue&type=script&lang=js&"
import style0 from "./inviteSwitch.vue?vue&type=style&index=0&id=f260a898&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f260a898",
  null
  
)

component.options.__file = "inviteSwitch.vue"
export default component.exports